import { Wifi, WifiOff, CloudOff } from 'lucide-react';
import { useOfflineStatus } from '@/hooks/useOfflineStatus';
import { AccountMenu } from '@/components/AccountMenu';

interface AppHeaderProps {
  title?: string;
}

function OfflineBadges() {
  const { isOnline, pendingRequests } = useOfflineStatus();
  return (
    <div className="flex items-center gap-2">
      {pendingRequests > 0 && (
        <div className="flex items-center gap-1.5 text-xs bg-zimmermann-gelb text-foreground px-2 py-1 rounded-full font-medium">
          <CloudOff className="w-4 h-4" />
          <span>{pendingRequests}</span>
        </div>
      )}
      {isOnline ? (
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <Wifi className="w-4 h-4" />
          <span className="hidden sm:inline">Online</span>
        </div>
      ) : (
        <div className="flex items-center gap-1.5 text-xs bg-zimmermann-rot text-white px-2 py-1 rounded-full font-medium">
          <WifiOff className="w-4 h-4" />
          <span>Offline</span>
        </div>
      )}
    </div>
  );
}

export function AppHeader({ title = 'Zimmermann' }: AppHeaderProps) {
  return (
    <header className="sticky top-0 z-40">
      {/* ---- Mobil: Marken-Bar mit Logo, Titel, Online-Status + Konto-Ecke ---- */}
      {/* bg-primary + safe-area-top: Blau füllt den Notch, Inhalt sitzt darunter
          → auf iPhone-PWA nicht mehr hinter Uhrzeit/Akku, wieder klickbar. */}
      <div className="md:hidden bg-primary safe-area-top">
        <div className="brand-stripe" />
        <div className="text-primary-foreground">
          <div className="flex items-center justify-between px-4 py-3">
            <div className="flex items-center gap-3 min-w-0">
              <div className="w-10 h-10 rounded-lg bg-primary-foreground flex items-center justify-center overflow-hidden flex-shrink-0">
                <img src="/logo.png" alt="Ludwig Zimmermann" className="w-full h-full object-contain p-1" />
              </div>
              <h1 className="font-semibold text-lg truncate">{title}</h1>
            </div>
            <div className="flex items-center gap-3">
              <div className="text-primary-foreground/90">
                <OfflineBadges />
              </div>
              <AccountMenu variant="compact" />
            </div>
          </div>
        </div>
      </div>

      {/* ---- Desktop: schlanke Leiste (Sidebar liefert Marke + Nav + Konto) ---- */}
      <div className="hidden md:block bg-background/80 backdrop-blur border-b border-border">
        <div className="flex items-center justify-between px-6 py-3">
          <h1 className="font-semibold text-lg text-foreground truncate">{title}</h1>
          <OfflineBadges />
        </div>
      </div>
    </header>
  );
}
